import { createDynamicSlice } from ".";
import { fetchUsersThunk } from "../thunks/usersThunk";

export const usersSlice = createDynamicSlice({
  name: "users",
  thunk: fetchUsersThunk,
  listMode: true,
  resetActionName: "resetUsers",
});

export const usersReducer = usersSlice.reducer;
export const { resetUsers } = usersSlice.actions;
